<template>
  <div>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <h1 style="font-weight: 600; font-size: 28px;" class="mr-4">Model Quick Reply</h1>
            </v-col>
            <v-col cols="12" md="6" class="d-flex flex-wrap justify-end gap-2">
              <div class="custom-search-input-wrapper">
                <div class="custom-search-input-container">
                  <v-icon class="custom-search-input-icon">mdi-magnify</v-icon>
                  <input id="modelgroup-field-search-setupgroupmodel" type="text" placeholder="Quick Reply Group Name"
                    class="custom-search-input" v-model="searchName" @keydown.enter="Search" />
                  <v-icon class="clear-icon" :style="searchName ? '' : 'color: transparent !important;'"
                    @click="searchName = ''">
                    mdi-close-circle
                  </v-icon>
                </div>
              </div>
              <v-btn
                id="button-add-popupadd-modelquickgroup"
                color="primary"
                class="control-btn create-btn customadd"
                variant="flat"
                size="large"
                prepend-icon="mdi-plus"
                rounded="xl"
                @click="Add()"
              >
                {{ $t("add") }}
                <v-tooltip activator="parent" location="top">Add Quick Reply</v-tooltip>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          :items="menus"
          :headers="headers"
          :loading="loadingTable"
          class="pa-5"
        >
          <template v-slot:item="{ item,index }">
            <tr>
              <td style="text-align: center">{{ (options.page - 1) * options.itemsPerPage + index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td style="text-align: left">
                <div class="model-chips-container">
                  <!-- Show first 2 model chips -->
                  <template
                    v-if="item.modelNameTable && item.modelNameTable !== '' && item.modelNameTable !== 'All Model'">
                    <v-chip v-for="(model, idx) in getModelChips(item.modelNameTable).slice(0, 2)" :key="idx"
                      size="small" variant="tonal" class="model-chip-item">
                      {{ model }}
                    </v-chip>

                    <!-- Show remaining count chip -->
                    <v-chip v-if="getModelChips(item.modelNameTable).length > 2" size="small" class="model-chip-count">
                      +{{ getModelChips(item.modelNameTable).length - 2 }}
                    </v-chip>
                  </template>

                  <!-- Show "All Model" chip -->
                  <v-chip v-else-if="item.modelNameTable === 'All Model'" size="small" variant="tonal"
                    class="model-chip-item">
                    All Model
                  </v-chip>

                  <!-- Show dash for empty -->
                  <span v-else class="text-grey">-</span>
                </div>
              </td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- View Details -->
                  <v-btn icon variant="text" density="comfortable"
                    v-show="item.modelNameTable != 'All Model' && item.modelNameTable != ''" @click="Detail(item)"
                    class="detail-btn">
                    <v-img :src="images.viewdetailImg" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      View Details
                    </v-tooltip>
                  </v-btn>
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-popupedit-modelquickreply"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-img :src="images.editBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      Edit
                    </v-tooltip>
                  </v-btn>             
                  <!-- Delete -->
                  <v-btn
                    id="button-delete-popupdelete-modelquickreply"
                    variant="text"
                    density="comfortable"
                    @click="DeleteGroup(item.modelQuickGroupID)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-img :src="images.deleteBtn" width="23" height="23"></v-img>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
          <!-- 👇 Custom footer area -->
          <template v-slot:bottom>
            <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
              <div>Total results {{ searchTotalTable }}</div>

              <v-data-table-footer v-model:items-per-page="itemsPerPage" :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)" />
            </div>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <!-- Loading Please Wait... -->
    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Edit -->

    <!-- Edit -->
    <v-dialog v-model="Editdialog" max-width="1200px" persistent scrollable class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">Edit Quick Reply Group</h2>
                <v-chip v-if="GroupModel.Model && GroupModel.Model.length > 0" size="small" variant="tonal" color="info"
                  class="summary-chip">
                  <span v-if="GroupModel.isAllModel">All models included</span>
                  <span v-else>{{ GroupModel.Model.length }} command configured</span>
                </v-chip>
              </div>
              <p class="dialog-subtitle">Create a new model shortcut group</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="closeEditDialog" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        
        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex align-center"> <v-img :src="images.basicInfo" width="20" height="20"
                    class="mr-3"></v-img> Basic Information</h3>
              </div>
              
              <v-row>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="input-label">
                      <span>Quick Reply Group Name</span>
                      <span class="required-asterisk">*</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Enter the title for this collection of related quick reply suggestions for easy management and identification.</span>
                      </v-tooltip>
                    </div>
                    
                    <v-text-field
                      id="quickreplygroupname-field-popupedit-modelquickreply"
                      v-model="GroupModel.Name"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="comfortable"
                      placeholder="Enter group name..."
                      hide-details="auto"
                      class="modern-input"
                    />
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="input-label">
                      <span>Import from Shortcut</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Select a shortcut group that will add the selected group's model to current configuration</span>
                      </v-tooltip>
                    </div>
                  <div class="input-wrapper">
                <v-autocomplete
                  id="shortcutgroup-autocomplete-popupeditimport-modelquickreply"
                  :items="filteredQuickGroup"
                  v-model="importData"
                  item-title="name"
                  item-value="modelQuickGroupID"
                  variant="outlined"
                  density="comfortable"
                  clearable
                  class="modern-input import-autocomplete"
                  hide-details="auto"
                  placeholder="Select Shortcut Group"
                  @update:model-value="handleImportSelection"
                >
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item 
                      v-bind="props"
                      :id="'shortcutgroup-import-modelquickreply-option-' + index" 
                      :value="item.raw.name"
                    >
                      <template v-slot:title>
                        <span>{{ item.raw.name }}</span>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
                </v-col>
                <!-- <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="input-label">
                      <span>Import From Shortcut</span>
                    </div>
                    
                    <v-btn
                      id="button-shortcutgroup-popupeditimport-modelquickreply"
                      color="primary"
                      variant="outlined"
                      class="import-btn"
                      @click="importDialogShow"
                    >
                      <v-icon class="mr-2">mdi-download</v-icon>
                      Shortcut Group
                      <v-tooltip activator="parent" location="top">
                        Import group from shortcut group
                      </v-tooltip>
                    </v-btn>
                  </div>
                </v-col> -->
              </v-row>
            </div>
          </div>
          <div class="form-container mt-5">
            <!-- Model Configuration Section -->
            <div class="form-section">
              <div class="form-section">
                <div class="section-header">
                  <h3 class="section-title d-flex align-center"> <v-img :src="images.modelSetup" width="20" height="20"
                      class="mr-3"></v-img> Model Setup</h3>
                  <v-chip
                    v-if="GroupModel.Model && GroupModel.Model.length > 0"
                    size="small"
                    variant="tonal"
                    color="info"
                    class="summary-chip ml-3"
                  >
                    {{ GroupModel.Model.length }} {{ GroupModel.Model.length === 1 ? 'model' : 'models' }}
                  </v-chip>
                  <v-spacer></v-spacer> 
                      <div class="checkbox-wrapper">
                        <v-checkbox
                          id="allmodel-checkbox-popupedit-modelquickreply"
                          v-model="GroupModel.isAllModel"
                          color="#C32E0E"
                          hide-details
                          @update:model-value="clearModel"
                          density="comfortable"
                          class="modern-checkbox"
                        >
                          <template v-slot:label>
                            <div class="checkbox-label">
                              <span>Add All Models</span>
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                </div>
              </div>
              <!-- Models Table -->
              <div class="table-container" v-if="!GroupModel.isAllModel">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th class="table-header">#</th>
                      <th class="table-header model-col">Model Name
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Choose models for this quick reply group</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header actions-col" style="text-align: center;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in GroupModel.Model"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell model-cell">
                        <v-autocomplete
                          :id="'model-autocomplete-popupedit-modelquickreply-' + index"
                          :disabled="GroupModel.isAllModel"
                          placeholder="Select Model"
                          v-model="item.modelID"
                          :items="filteredModels(index)"
                          item-title="name"
                          item-value="modelDisplayID"
                          hide-details
                          clearable
                          variant="outlined"
                          density="compact"
                          class="table-autocomplete"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'model-edit-modelquickreply-option-' + index" 
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                      
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :id="'button-deleterowmodel1-popupedit-modelquickreply-' + index"
                            :disabled="index == 0 && GroupModel.Model.length == 1"
                            icon
                            variant="text"
                            size="small"
                            color="error"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_ModelQuick(index)"
                          >
                            <v-icon>mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Remove Command
                            </v-tooltip>
                          </v-btn>
                          <v-btn
                            :id="'button-addrowmodel1-popupedit-modelquickreply-' + index"
                            icon
                            variant="text"
                            size="small"
                            color="success"
                            class="actionbtns addbtn"
                            @click="Plus_ModelQuick(index)"
                          >
                            <v-icon>mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Add Command
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </div>
          <div class="form-container mt-5">
            <!-- Quick Reply Commands Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex align-center"> <v-img :src="images.quickReply" width="20" height="20"
                    class="mr-3"></v-img> {{ $t("Quick Reply Command") }}</h3>
                    <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>configure quick reply commands with labels, messages and custom icons</span>
                      </v-tooltip>
                <v-chip
                  v-if="GroupModel.commandList && GroupModel.commandList.length > 0"
                  size="small"
                  variant="tonal"
                  color="info"
                  class="summary-chip ml-3"
                >
                  {{ GroupModel.commandList.length }} {{ GroupModel.commandList.length === 1 ? 'command' : 'commands' }}
                </v-chip>
              </div>
            </div>
            <!-- Quick Reply Commands Table -->
              <div class="table-container">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th class="table-header">#</th>
                      <th class="table-header">{{ $t("Label") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Name of the quick reply</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header">{{ $t("Message") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Reply text sent to chat</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header">{{ $t("Type") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Postback is the type that the user not seeing any sent data.
                                <br />Message is the type that the user sees sent data.
                              </span>
                            </v-tooltip>
                      </th>
                      <th class="table-header" style="text-align: center;">{{ $t("UploadImage") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Select an icon for this reply</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header" style="text-align: center; min-width: 150px;">Icon Preview</th>
                      <th class="table-header actions-col" style="text-align: center;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in GroupModel.commandList"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell label-cell">
                        <v-text-field
                          :id="'label-field-popupedit-modelquickreply-' + index"
                          v-model="item.label"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          placeholder="Quick reply name"
                        />
                      </td>
                      
                      <td class="table-cell label-cell">
                        <v-text-field
                          :id="'message-field-popupedit-modelquickreply-' + index"
                          v-model="item.data"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                          placeholder="Quick reply data"
                        />
                      </td>
                      
                      <td class="table-cell label-cell">
                        <v-autocomplete
                          :id="'type-field-popupedit-modelquickreply-' + index"
                          v-model="item.type"
                          :items="quickReplyType"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-autocomplete"
                          hide-no-data
                          width="165"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'type-edit-modelquickreply-option-' + index" 
                              :value="item.raw"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                      
                      <td class="table-cell upload-cell">
                        <v-btn
                          :id="'button-upload-popupedit-modelquickreply-' + index"
                          color="#C32E0E"
                          variant="outlined"
                          size="small"
                          class="upload-btn"
                          @click="Click_FileButtonQuickReply(index)"
                        >
                          <v-img :src="images.iconcolImg" class="mr-2" width="16" height="16" alt="Upload"></v-img>
                          {{ $t("UploadImage") }}
                          <v-tooltip v-if="item.iconFileURL && item.iconFileURL !== ''" activator="parent" location="top">
                              Change Icon
                          </v-tooltip>
                          <v-tooltip v-else activator="parent" location="top">
                              Upload Icon
                            </v-tooltip>
                        </v-btn>
                      </td>
                      
                      <td class="table-cell preview-cell">
                        <div class="image-preview">
                          <div
                            class="preview-avatar"
                          >
                            <img
                              v-if="item.iconFileURL && item.iconFileURL !== ''"
                              :src="item.iconFileURL"
                              alt="Preview"
                            />
                            <v-img v-else :src="images.iconpreviewImg"></v-img>
                        </div>
                        </div>
                      </td>
                      
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :id="'button-deleterowmodel-popupedit-modelquickreply-' + index"
                            :disabled="index == 0 && GroupModel.commandList.length == 1"
                            icon
                            variant="text"
                            size="small"
                            color="error"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_QuickReply(index)"
                          >
                            <v-icon size="30">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Remove Command
                            </v-tooltip>
                          </v-btn>
                          
                          <v-btn
                            :id="'button-addrowmodel-popupedit-modelquickreply-' + index"
                            icon
                            variant="text"
                            size="small"
                            color="success"
                            class="actionbtns addbtn"
                            @click="Plus_QuickReply(index)"
                          >
                            <v-icon size="30">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Add Command
                            </v-tooltip>
                          </v-btn>
                          
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          
          <!-- Hidden file input -->
          <input
            id="inputfileQuickReply-edit"
            ref="bindFileNameQuickReply"
            type="file"
            @change="QuickReplyIcon"
            style="display: none"
            accept="image/png,image/jpeg"
          />
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions">
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="closeEditDialog"
                class="dialog-action-btn cancel-btn"
              >
                {{ $t("cancel") }}
              </v-btn>

              <v-btn
                id="button-save-popupedit-modelquickreply"
                variant="elevated"
                @click="Save"
                class="dialog-action-btn save-btn-edit"
                :loading="dialog"
              >
                <v-img :src="images.saveImg" width="20" height="20" class="mr-2" />
                {{ $t("save") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add -->
    <v-dialog v-model="Adddialog" max-width="1200px" persistent scrollable class="modern-dialog">
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">Add Quick Reply Group</h2>
                <v-chip v-if="GroupModel.Model && GroupModel.Model.length > 0" size="small" variant="tonal" color="info"
                  class="summary-chip">
                  <span v-if="GroupModel.isAllModel">All models included</span>
                  <span v-else>{{ GroupModel.Model.length }} command configured</span>
                </v-chip>
              </div>
              <p class="dialog-subtitle">Create a new model shortcut group</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="closeAddDialog" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- Content -->
        <v-card-text class="dialog-content">
          <div class="form-container">
            <!-- Basic Information Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex align-center"> <v-img :src="images.basicInfo" width="20" height="20"
                    class="mr-3"></v-img> Basic Information</h3>
              </div>
              
              <v-row>
                <v-col cols="12" md="6">
                  <div class="input-wrapper">
                    <div class="input-label">
                      <span>Quick Reply Group Name</span>
                      <span class="required-asterisk">*</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Enter the title for this collection of related quick reply suggestions for easy management and identification.</span>
                      </v-tooltip>
                    </div>
                    
                    <v-text-field
                      id="quickreplygroupname-field-popupadd-modelquickreply"
                      v-model="GroupModel.Name"
                      :rules="[rules.required]"
                      variant="outlined"
                      density="comfortable"
                      placeholder="Enter Group name..."
                      hide-details="auto"
                      class="modern-input"
                    />
                  </div>
                </v-col>
                
                <v-col cols="12" md="6">
                  <div class="input-label">
                      <span>Import from Shortcut</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>Select a shortcut group that will add the selected group's model to current configuration</span>
                      </v-tooltip>
                    </div>
                  <div class="input-wrapper">
                <v-autocomplete
                  id="shortcutgroup-autocomplete-popupaddimport-modelquickreply"
                  :items="filteredQuickGroup"
                  v-model="importData"
                  item-title="name"
                  item-value="modelQuickGroupID"
                  variant="outlined"
                  density="comfortable"
                  clearable
                  class="modern-input import-autocomplete"
                  hide-details="auto"
                  placeholder="Select Shortcut Group"
                  @update:model-value="handleImportSelection"
                >
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item 
                      v-bind="props"
                      :id="'shortcutgroup-import-modelquickreply-option-' + index" 
                      :value="item.raw.name"
                    >
                      <template v-slot:title>
                        <span>{{ item.raw.name }}</span>
                      </template>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
                    <!-- <v-btn
                      id="button-shortcutgroup-popupimport-modelquickreply"
                      color="primary"
                      variant="outlined"
                      class="import-btn"
                      @click="importDialogShow"
                    >
                      <v-icon class="mr-2">mdi-download</v-icon>
                      Shortcut Group
                      <v-tooltip activator="parent" location="top">
                        Import group from shortcut group
                      </v-tooltip>
                    </v-btn> -->
                </v-col>
              </v-row>
            </div>
          </div>
          <div class="form-container mt-5">
            <!-- Model Configuration Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex align-center"> <v-img :src="images.modelSetup" width="20" height="20"
                    class="mr-3"></v-img> Model Setup</h3>
                <v-chip
                  v-if="GroupModel.Model && GroupModel.Model.length > 0"
                  size="small"
                  variant="tonal"
                  color="info"
                  class="summary-chip ml-3"
                >
                  {{ GroupModel.Model.length }} {{ GroupModel.Model.length === 1 ? 'model' : 'models' }}
                </v-chip>
                <v-spacer></v-spacer> 
                    <div class="checkbox-wrapper">
                      <v-checkbox
                        id="allmodel-checkbox-popupadd-modelquickreply"
                        v-model="GroupModel.isAllModel"
                        color="#C32E0E"
                        hide-details
                        @update:model-value="clearModel"
                        density="comfortable"
                        class="modern-checkbox"
                      >
                        <template v-slot:label>
                          <div class="checkbox-label">
                            <span>Add All Models</span>
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
              </div>

              <!-- Models Table -->
              <div class="table-container" v-if="!GroupModel.isAllModel" >
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th class="table-header">#</th>
                      <th class="table-header model-col">Model Name
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Choose models for this quick reply group</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header actions-col" style="text-align: center;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in GroupModel.Model"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell model-cell">
                        <v-autocomplete
                          :id="'model-autocomplete-popupadd-modelquickreply-' + index"
                          :disabled="GroupModel.isAllModel"
                          placeholder="Select Model"
                          v-model="item.modelID"
                          :items="filteredModels(index)"
                          item-title="name"
                          item-value="modelDisplayID"
                          hide-details
                          clearable
                          variant="outlined"
                          density="compact"
                          class="table-autocomplete"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'model-add-modelquickreply-option-' + index" 
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                      
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :disabled="index == 0 && GroupModel.Model.length == 1"
                            icon
                            variant="text"
                            size="small"
                            color="error"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_ModelQuick(index)"
                          >
                            <v-icon size="30">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Remove Model
                            </v-tooltip>
                          </v-btn>
                          <v-btn
                            :id="'button-addrowmodel1-popupadd-modelquickreply-' + index"
                            icon
                            variant="text"
                            size="small"
                            color="success"
                            class="actionbtns addbtn"
                            @click="Plus_ModelQuick(index)"
                          >
                            <v-icon size="30">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Add Model
                            </v-tooltip>
                          </v-btn>
                          
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
              <!-- All Model Info -->
            <div v-else class="form-section">
              <div class="all-model-info">
                <h3 class="info-title"><v-icon size="20" color="success" class="mr-1">mdi-check-circle-outline</v-icon>All Models Included</h3>
                <p class="info-subtitle">This group will automatically include all available models</p>
              </div>
            </div>
            </div>
          </div>
          <div class="form-container mt-5">
            <!-- Quick Reply Commands Section -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title d-flex align-center"> <v-img :src="images.quickReply" width="20" height="20"
                    class="mr-3"></v-img> {{ $t("Quick Reply Command") }}</h3>
                    <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="small"
                            v-bind="props"
                            color="grey-darken-1"
                            class="help-icon mr-2"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>configure quick reply commands with labels, messages and custom icons</span>
                      </v-tooltip>
                <v-chip
                  v-if="GroupModel.commandList && GroupModel.commandList.length > 0"
                  size="small"
                  variant="tonal"
                  color="info"
                  class="summary-chip ml-3"
                >
                  {{ GroupModel.commandList.length }} {{ GroupModel.commandList.length === 1 ? 'command' : 'commands' }}
                </v-chip>
              </div>

              <!-- Quick Reply Commands Table -->
              <div class="table-container">
                <v-table class="modern-table" density="compact">
                  <thead>
                    <tr>
                      <th class="table-header">#</th>
                      <th class="table-header">{{ $t("Label") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Name of the quick reply</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header">{{ $t("Message") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Reply text sent to chat</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header">{{ $t("Type") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Postback is the type that the user not seeing any sent data.
                                <br />Message is the type that the user sees sent data.
                              </span>
                            </v-tooltip>
                      </th>
                      <th class="table-header" style="text-align: center;">{{ $t("UploadImage") }}
                        <v-tooltip location="top" max-width="300px">
                              <template v-slot:activator="{ props }">
                                <v-icon
                                  size="small"
                                  v-bind="props"
                                  color="grey-darken-1"
                                >
                                  mdi-information-outline
                                </v-icon>
                              </template>
                              <span>Select an icon for this reply</span>
                            </v-tooltip>
                      </th>
                      <th class="table-header" style="text-align: center; min-width: 150px;">Icon Preview</th>
                      <th class="table-header actions-col" style="text-align: center;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in GroupModel.commandList"
                      :key="index"
                      class="table-row"
                    >
                      <td class="table-cell number-cell">{{ index + 1 }}</td>
                      
                      <td class="table-cell label-cell">
                        <v-text-field
                          :id="'label-field-popupadd-modelquickreply-' + index"
                          :placeholder="$t('Label')"
                          v-model="item.label"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                        />
                      </td>
                      
                      <td class="table-cell label-cell">
                        <v-text-field
                          :id="'message-field-popupadd-modelquickreply-' + index"
                          :placeholder="$t('Message')"
                          v-model="item.data"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-input"
                        />
                      </td>
                      
                      <td class="table-cell label-cell">
                        <v-autocomplete
                          :id="'type-autocomplete-popupadd-modelquickreply-' + index"
                          :placeholder="$t('Type')"
                          v-model="item.type"
                          :items="quickReplyType"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="table-autocomplete"
                          hide-no-data
                          width="165"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'type-add-modelquickreply-option-' + index" 
                              :value="item.raw"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </td>
                      
                      <td class="table-cell upload-cell">
                        <v-btn
                          :id="'button-upload-popupadd-modelquickreply-' + index"
                          color="#C32E0E"
                          variant="outlined"
                          size="small"
                          class="upload-btn"
                          @click="Click_FileButtonQuickReply(index)"
                        >
                          <v-img :src="images.iconcolImg" class="mr-2" width="16" height="16" alt="Upload"></v-img>
                          {{ $t("UploadImage") }}
                          <v-tooltip v-if="item.iconFileURL && item.iconFileURL !== ''" activator="parent" location="top">
                              Change Icon
                          </v-tooltip>
                          <v-tooltip v-else activator="parent" location="top">
                              Upload Icon
                            </v-tooltip>
                        </v-btn>
                      </td>
                      
                      <td class="table-cell preview-cell">
                        <div class="image-preview">
                          <div
                            class="preview-avatar"
                          >
                            <img
                              v-if="item.iconFileURL && item.iconFileURL !== ''"
                              :src="item.iconFileURL"
                              alt="Preview"
                            />
                            <v-img v-else :src="images.iconpreviewImg"></v-img>
                        </div>
                        </div>
                      </td>
                      
                      <td class="table-cell actions-cell">
                        <div class="action-buttons">
                          <v-btn
                            :disabled="index == 0 && GroupModel.commandList.length == 1"
                            icon
                            variant="text"
                            size="small"
                            color="error"
                            class="actionbtns removebtns mr-4"
                            @click="Minus_QuickReply(index)"
                          >
                            <v-icon size="30">mdi-minus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Remove Command
                            </v-tooltip>
                          </v-btn>
                          <v-btn
                            :id="'button-addrowmodel-popupadd-modelquickreply-' + index"
                            icon
                            variant="text"
                            size="small"
                            color="success"
                            class="actionbtns addbtn"
                            @click="Plus_QuickReply(index)"
                          >
                            <v-icon size="30">mdi-plus</v-icon>
                            <v-tooltip activator="parent" location="top">
                              Add Command
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>
            </div>
          </div>
          <!-- Hidden file input -->
          <input
            id="inputfileQuickReply-add"
            ref="bindFileNameQuickReply"
            type="file"
            @change="QuickReplyIcon"
            style="display: none"
            accept="image/png,image/jpeg"
          />
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions">
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="closeAddDialog"
                class="dialog-action-btn cancel-btn"
              >
                {{ $t("cancel") }}
              </v-btn>

              <v-btn
                id="button-save-popupadd-modelquickreply"
                variant="elevated"
                @click="Save"
                class="dialog-action-btn save-btn-add"
                :loading="dialog"
              >
                <v-img :src="images.saveImg" width="20" height="20" class="mr-2"/>
                {{ $t("save") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Details -->
    <v-dialog v-model="Detaildialog" max-width="600px">
      <v-card class="detail-dialog">
        <!-- Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-text-content">
              <div class="title-with-chip">
                <h2 class="dialog-title">View Details</h2>
                <v-chip v-if="TempModel.length > 0" size="small" variant="tonal" class="summary-chip mb-2">
                  {{ TempModel.length }} models
                </v-chip>
              </div>
              <p class="dialog-subtitle">Model Details and Information</p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn icon variant="text" @click="Detaildialog = false" class="close-button">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <!-- Dialog Content -->
        <v-card-text class="detail-content">
          <div class="models-container">
            <!-- Empty State -->
            <div v-if="TempModel.length === 0" class="empty-state">
              <v-icon size="64" color="grey-lighten-2">mdi-robot-off</v-icon>
              <div class="text-h6 text-grey-darken-1 mt-4">No models found</div>
              <div class="text-body-2 text-grey">No model data available to display</div>
            </div>

            <!-- Model List -->
            <div v-else class="model-list">
              <div
                v-for="(item, index) in TempModel"
                :key="item.id"
                class="model-item"
                :class="{ 'last-item': index === TempModel.length - 1 }"
              >
                <div class="model-card">
                  <div class="model-content">
                    <div class="model-info">
                      <div class="model-icon-wrapper">
                        <v-img :src="images.modeldetailImg" width="20" height="20"></v-img>
                      </div>
                      <div class="model-details">
                        <h4 class="model-name">{{ item.name }}</h4>
                      </div>
                    </div>
                    
                    <div class="model-actions">
                      <v-btn
                        variant="outlined"
                        size="small"
                        class="view-btn"
                        @click="View(item)"
                      >
                        <v-icon size="16" class="mr-1">mdi-eye</v-icon>
                        View
                      </v-btn>
                    </div>
                  </div>
                </div>
                
                <!-- Divider (except for last item) -->
                <v-divider
                  v-if="index < TempModel.length - 1"
                  class="model-divider"
                ></v-divider>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Dialog Actions -->
        <v-card-actions class="detail-actions">
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="Detaildialog = false"
                class="control-btn create-btn customadd mr-0"
              >
              <v-icon class="mr-2">mdi-close</v-icon>
                {{ $t("close") }}
              </v-btn>
            </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Custom Delete Dialog -->
    <v-dialog v-model="dialog_delete" max-width="600px" persistent>
      <v-card class="delete-dialog-card">
        <div class="delete-dialog-header">
          <span class="delete-dialog-title">Delete Confirmation</span>
          <v-btn
            icon
            variant="text"
            size="small"
            class="delete-close-icon"
            @click="cancelDelete"
          >
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        
        <!-- Content -->
        <v-card-text class="delete-dialog-content">
          <span v-if="deleteItem">
            Do you want to confirm deletion of this model shortcut?
          </span>
        </v-card-text>
        
        <!-- Actions -->
        <v-card-actions class="delete-dialog-actions">
          <v-btn
            class="delete-cancel-btn"
            @click="cancelDelete"
          >
            Cancel
          </v-btn>
          <v-btn
            class="delete-confirm-btn"
            @click="confirmDelete"
          >
            <v-img :src="images.deleteIcon" width="20" height="20" class="mr-2"/>
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Shortcut group import -->
    <v-dialog v-model="importDialog" max-width="600px" persistent>
      <v-card class="modern-dialog import-dialog">
        <!-- Header -->
        <v-card-title class="dialog-header import-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon size="28" color="white">mdi-download</v-icon>
              </div>
              <div class="header-text">
                <h2 class="dialog-title">Import Shortcut Group</h2>
                <p class="dialog-subtitle">Select a shortcut group to import</p>
              </div>
            </div>
            <div class="header-right">
              <v-btn
                icon
                variant="text"
                @click="importDialog = false"
                class="close-btn"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-title>

        <!-- Content -->
        <v-card-text class="dialog-content import-content">
          <div class="form-container">
            <div class="form-section">
              <div class="section-header">
                <v-icon size="20" color="primary" class="mr-2">mdi-folder-multiple-outline</v-icon>
                <h3 class="section-title">Select Shortcut Group</h3>
              </div>
              
              <div class="input-wrapper">
                <div class="input-label">
                  <span>Available Shortcut Groups</span>
                  <span class="required-asterisk">*</span>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        size="small"
                        v-bind="props"
                        color="grey-darken-1"
                        class="help-icon"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Choose a shortcut group to import its models</span>
                  </v-tooltip>
                </div>
                
                <v-autocomplete
                  id="shortcutgroup-autocomplete-popupcopyimport-modelquickreply"
                  :items="QuickGroup"
                  v-model="importData"
                  label="Select shortcut group"
                  item-title="name"
                  item-value="modelQuickGroupID"
                  variant="outlined"
                  density="comfortable"
                  clearable
                  class="modern-input import-autocomplete"
                  hide-details="auto"
                  placeholder="Choose a shortcut group..."
                  prepend-inner-icon="mdi-folder-search-outline"
                >
                  <template v-slot:item="{ props, item, index }">
                    <v-list-item 
                      v-bind="props"
                      :id="'shortcutgroup-import-modelquickreply-option-' + index" 
                      :value="item.raw.name"
                    >
                      <template v-slot:title>
                        <span>{{ item.raw.name }}</span>
                      </template>
                    </v-list-item>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="small"
                          v-bind="props"
                          color="grey-darken-1"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>Select a shortcut group to import</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </div>
              
              <!-- Info Message -->
              <div class="info-message import-info">
                <v-icon size="16" color="info" class="mr-2">mdi-information-outline</v-icon>
                <span>Importing will add the selected group's models to your current configuration</span>
              </div>
            </div>
          </div>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="dialog-actions import-actions">
          <div class="actions-content">
            <div class="actions-left">
              <v-chip
                v-if="QuickGroup && QuickGroup.length > 0"
                size="small"
                variant="tonal"
                color="info"
                class="summary-chip"
              >
                <v-icon size="14" class="mr-1">mdi-folder-multiple</v-icon>
                {{ QuickGroup.length }} available group{{ QuickGroup.length === 1 ? '' : 's' }}
              </v-chip>
            </div>
            
            <div class="actions-right">
              <v-btn
                variant="outlined"
                color="grey"
                @click="importDialog = false"
                class="dialog-action-btn cancel-btn"
              >
                <v-icon class="mr-2">mdi-close</v-icon>
                Cancel
              </v-btn>

              <v-btn
                id="button-import-popupadd-modelquickreply"
                color="success"
                variant="elevated"
                @click="importDialogConfirm"
                class="dialog-action-btn import-btn-action"
                :disabled="!importData"
              >
                <v-icon class="mr-2">mdi-download</v-icon>
                Import
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
import viewdetailImg from "@/assets/images/eyedetail.svg";
import editBtn from '@/assets/images/editbutton.png';
import deleteBtn from '@/assets/images/trashbutton.png';
import modeldetailImg from '@/assets/images/modeldetail.svg';
import deleteIcon from "@/assets/images/trash-solid.svg";
import basicInfo from "@/assets/images/basicinfo.png";
import modelSetup from "@/assets/images/modelsetup.png";
import saveImg from '@/assets/images/savecard.png';
import uploadImg from '@/assets/images/uploadimg.png';
import previewImg from '@/assets/images/preview.png';
import quickReply from '@/assets/images/quickgroup.png';
import iconcolImg from '@/assets/images/iconcol.png';
import iconpreviewImg from '@/assets/images/iconpreview.png';
export default {
  name: "ModelQuickReply",
  mixins: [checkPermissionTwo],
  inject:['FontColorTitle','SubNavbarBackGround'],
  data: () => ({
    indexImportFile: null,

    importData: null,
    checkbox1: false,
    Editdialog: false,
    Adddialog: false,
    Detaildialog: false,
    dialog: false,
    loading: false,
    valid: true,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: 0,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDGPTModel: [],
    headers_version_history: [],

    searchName: "",
    isSearch: false,
    isFirst: true,
    menus: [],
    QuickGroup: [],
    quickReplyType: ["postback", "message"],
    images: {
      edit: editImg,
      delete: deleteImg,
      viewdetailImg: viewdetailImg,
      editBtn: editBtn,
      deleteBtn: deleteBtn,
      modeldetailImg: modeldetailImg,
      deleteIcon: deleteIcon,
      basicInfo: basicInfo,
      modelSetup: modelSetup,
      saveImg: saveImg,
      uploadImg: uploadImg,
      previewImg: previewImg,
      quickReply: quickReply,
      iconcolImg: iconcolImg,
      iconpreviewImg: iconpreviewImg,
    },
    dialog_delete: false,
    deleteItem: null,
    GroupModel: {
      modelQuickGroupID: null,
      Name: null,
      Model: [],
      isAllModel: false,
      commandList: [
        {
          id: 0,
          label: null,
          data: null,
          type: null,
          modelQuickGroupID: null,
          iconFileURL: null,
          imgName: null,
        },
      ],
    },
    importDialog: false,
    TempModel: [],
    dialog_replace: false,
    replace_modelid: 0,
    replace_modelid_list: { id: 0, name: "x" },
    replace_modelid_lists: [], //{id:0, name: "x"}
    dialog_version: false,
    menus_version: [],
    menus_modeliddisplay_version: 0,
    searchTotalTable_version: 0,
    totalTable_version: 0,
    itemsPerPage_version: 5,
    sortBy: [],
    sortDesc: [],
  }),
  computed: {
    headers() {
      return [
        {
          title: this.$t("no"),
          align: "center",
          sortable: false,
          width: "95px",
        },
        {
          title: this.$t("Quick reply Group"),
          align: "left",
          sortable: true,
          value: "Name",
        },
        {
          title: this.$t("modelName"),
          align: "left",
          sortable: false,
          value: "ModelNameTable",
        },
        { title: this.$t("manage"), align: "center", sortable: false, width: "150px" },
      ];
    },
    areDialogsClosed() {
      return !this.Adddialog && !this.Editdialog;
    },
    // Add this computed property
    filteredQuickGroup() {
      if (this.Editdialog && this.GroupModel.modelQuickGroupID) {
        // When editing, exclude the current group
        return this.QuickGroup.filter(
          group => group.modelQuickGroupID !== this.GroupModel.modelQuickGroupID
        );
      }
      // When adding, show all groups
      return this.QuickGroup;
    },
  },
  watch: {
    areDialogsClosed(newVal) {
      if (newVal) {
        this.CommandClear();
      }
    },
    options: {
      handler() {
        this.Get();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleImportSelection(value) {
      let self = this;
      if (value) {
        self.importDialogConfirm();
      }
    },
    getModelChips(modelNameTable) {
      if (!modelNameTable || modelNameTable === '' || modelNameTable === 'All Model') {
        return [];
      }

      return modelNameTable
        .split(', ')
        .map(item => {
          const name = item.split(':')[0].trim();
          return name;
        })
        .filter(name => name !== '');
    },
    filteredModels(index) {
      const selectedModelIds = this.GroupModel.Model.filter(
        (_, idx) => idx !== index
      ).map((model) => model.modelID);

      return this.DDGPTModel.filter(
        (model) => !selectedModelIds.includes(model.modelDisplayID)
      );
    },
    RedundantCheck(input) {
      const values = input
        .filter(
          (item) => item["modelID"] !== null && item["modelID"] !== undefined
        )
        .map((item) => item["modelID"]);
      const foundDuplicates = values.filter(
        (value, index, self) => self.indexOf(value) !== index
      );
      return foundDuplicates.length > 0;
    },
    importDialogShow() {
      this.importDialog = true;
    },
    importDialogConfirm() {
      let self = this;
      if (self.GroupModel.isAllModel == false) {
        self.QuickGroup.forEach((eachGroup) => {
          if (eachGroup.modelQuickGroupID === self.importData) {
            self.GetDDModelQuick(eachGroup.modelQuickGroupID);
            self.importDialog = false;
            self.GroupModel.Model = self.GroupModel.Model.filter(
              (model) => model.modelID !== null
            );
          }
        });
      } else {
        alert("All model cannot import more group.");
        self.importDialog = false;
        return;
      }
    },
    CommandClear() {
      this.importData = null;
      this.GroupModel.modelQuickGroupID = 0;
      (this.GroupModel.commandList = [
        {
          id: 0,
          label: null,
          data: null,
          type: null,
          modelQuickGroupID: 0,
          iconFileURL: null,
          imgName: null,
        },
      ]),
        (this.GroupModel.Name = "");
      this.GroupModel.Model = null;
      this.GroupModel.isAllModel = false;
    },
    closeEditDialog() {
      this.importData = null;
      this.Editdialog = false;
    },
    closeAddDialog() {
      this.importData = null;
      this.Adddialog = false;
    },
    GetDDModelQuickReplyCommand(id) {
      let self = this;
      self.$call.GetDDModelQuickReplyCommand(
        id,
        (dataResponse) => {
          if (dataResponse.status === 0) {
            self.GroupModel.commandList = dataResponse.data;
            self.GroupModel.modelQuickGroupID = id;
            self.loading = false;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          self.loading = false;
          console.error(errorResource);
        }
      );
    },
    clearModel() {
      let self = this;
      if (self.GroupModel.isAllModel) {
        // self.GroupModel.Model = null;
        self.GroupModel.Model = [];
      } else {
        if (self.Adddialog) {
          self.GroupModel.Model = [
            {
              modelQuickID: null,
              name: "",
              modelID: null,
              modelQuickGroupID: null,
            },
          ];
        } else {
          self.GetModelGroupAndQuickReply(self.GroupModel.modelQuickGroupID);
        }
      }
    },
    Search() {
      let self = this;
      self.isSearch = true;
      self.options.page = 1;
      self.Get();
    },
    Get() {
      let self = this;
      self.loadingTable = true;

      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetQuickReplyGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.menus = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.GetDDGPTModel();
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDefault() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = self.options;

      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        name: self.searchName,
        sortDesc: null,
        sortBy: null,
      };
      self.$call.GetTableModelQuickGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.QuickGroup = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.menus = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetQuickGroup() {
      let self = this;
      self.$call.GetModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.QuickGroup = dataResponse.data.filter(
              (group) => group.isAllModel != true
            );
          }
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      self.loadingTable = true;
      self.$call.DDGPTModelIsPublish(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          self.loadingTable = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    DeleteGroup(id) {
      let self = this;
      self.deleteItem = id;
      self.dialog_delete = true;   
    },
    cancelDelete() {
      this.dialog_delete = false;
      this.deleteItem = null;
    },
    confirmDelete() {
      let self = this;
      if (!self.deleteItem) return;
      var id = self.deleteItem
      try { 
              self.dialog = true;
              self.dialog_delete = false;

              self.$call.DeleteQuickReplyGroup(
                id,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      title: "✔ Successfully Deleted !",
                      showConfirmButton: false,
                      timer: 1500,
                      position: 'top',
                      customClass: {
                        popup: 'success-banner',
                        title: 'success-banner-title'
                      },
                    });
                    
                    self.Get();
                  }
                  self.dialog = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  self.Adddialog = false;
                  console.error(errorResource);
                }
              );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.importData = null; 
      self.GroupModel.modelQuickGroupID = null;
      self.GroupModel.Name = null;
      // self.GroupModel.Model = null;
      // self.GroupModel.Model = [];
      self.GroupModel.Model = [
        {
          modelQuickID: null,
          name: "",
          modelID: null,
          modelQuickGroupID: null,
        },
      ];

      self.GroupModel.isAllModel = false;
      self.Adddialog = true;
    },
    Edit(item) {
      let self = this;
      self.importData = null;
      self.Editdialog = true;
      self.GroupModel.modelQuickGroupID = item.modelQuickGroupID;
      self.GroupModel.Name = item.name;
      self.GroupModel.Model = [];
      self.GroupModel.isAllModel = item.isAllModel;
      if (
        self.GroupModel.isAllModel == false ||
        self.GroupModel.isAllModel == null
      ) {
        self.GetModelGroupAndQuickReply(self.GroupModel.modelQuickGroupID);
      } else if (self.GroupModel.isAllModel == true) {
        self.GetModelQuickCommand(self.GroupModel.modelQuickGroupID);
      }
    },
    async GetModelGroupAndQuickReply(_modelQuickGroupID) {
      let self = this;
      try {
        self.dialog = true;
        await self.$call.GetModelGroupAndQuickReply(
          _modelQuickGroupID,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              self.GroupModel.Model = dataResponse.data.groupList;
              self.GroupModel.commandList = dataResponse.data.quickReplyList;
            }

            if (self.GroupModel.Model.length == 0) {
              self.GroupModel.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  modelQuickGroupID: null,
                },
              ];
            }
            if (self.GroupModel.commandList.length == 0) {
              self.GroupModel.commandList = [
                {
                  id: 0,
                  label: null,
                  data: null,
                  type: null,
                  createDate: null,
                  createBy: null,
                  updateDate: null,
                  updateBy: null,
                  modelQuickGroupID: null,
                  iconFileURL: null,
                  activeFlag: true,
                },
              ];
            }
            self.dialog = false;
          },
          () => {
            self.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async GetModelQuickCommand(_modelQuickGroupID) {
      let self = this;
      try {
        self.dialog = true;
        await self.$call.GetModelQuickCommand(
          _modelQuickGroupID,
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              //self.GroupModel.Model = dataResponse.data.groupList;
              self.GroupModel.commandList = dataResponse.data;
            }
            if (self.GroupModel.commandList.length == 0) {
              self.GroupModel.commandList = [
                {
                  id: 0,
                  label: null,
                  data: null,
                  type: null,
                  createDate: null,
                  createBy: null,
                  updateDate: null,
                  updateBy: null,
                  modelQuickGroupID: null,
                  iconFileURL: null,
                  activeFlag: true,
                },
              ];
            }
            self.dialog = false;
          },
          () => {
            self.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    async GetDDModelQuick(_modelQuickGroupID) {
      let self = this;
      try {
        self.dialog = true;
        await self.$call.GetDDModelQuick(
          { modelQuickGroupID: _modelQuickGroupID },
          async (dataResponse) => {
            if (dataResponse.status == 0) {
              if (
                self.GroupModel.Model.length == 1 &&
                self.GroupModel.Model[0].modelID == null &&
                self.GroupModel.Model[0].modelQuickGroupID == null &&
                self.GroupModel.Model[0].name == ""
              ) {
                self.GroupModel.Model = dataResponse.data;
              } else {
                let tempGroup = self.GroupModel.Model;
                self.GroupModel.Model = self.GroupModel.Model.concat(
                  dataResponse.data
                );
                if (self.RedundantCheck(self.GroupModel.Model)) {
                  self.dialog = false;
                  alert("The group must not have any duplicated models.");
                  self.GroupModel.Model = tempGroup;
                  self.importDialog = false;
                  return;
                }
              }
            }

            if (self.GroupModel.Model.length == 0 && dataResponse.data.length) {
              self.GroupModel.Model = [
                {
                  modelQuickID: null,
                  name: "",
                  modelID: null,
                  modelQuickGroupID: null,
                },
              ];
            }

            self.dialog = false;
          },
          () => {
            self.dialog = false;
          }
        );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    Detail(item) {
      let self = this;
      self.TempModel = [];
      self.Detaildialog = true;
      self.GroupModel.modelQuickGroupID = item.modelQuickGroupID;
      self.GroupModel.Name = item.name;
      self.GroupModel.Model = item.modelId;
      let dataLoop = item.modelName.split(", ");
      for (const element of dataLoop) {
        const name = element;
        const id = name.split(":")[1];
        let temp = {
          name: name.split(":")[0],
          id: id,
        };
        self.TempModel.push(temp);
      }
    },
    View(item) {
      let self = this;
      const routeData = self.$router.resolve({
        name: "GPTModelDetail",
        query: {
          id: item.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    Clear() {
      let self = this;
      self.GroupModel.modelQuickGroupID = null;
      self.GroupModel.commandList = null;
      self.GroupModel.Name = null;
      self.GroupModel.Model = null;
      self.GroupModel.isAllModel = false;
      self.Editdialog = false;
      self.Adddialog = false;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
    async Save() {
      let self = this;
      try {
        //    if (self.GroupModel.Name == '' || self.GroupModel.Name == null || ((self.GroupModel.Model == '' || self.GroupModel.Model == null) && self.GroupModel.isAllModel == false)) {

        /*
      if (self.GroupModel.Name == '' || self.GroupModel.Name == null || ( 
        (self.GroupModel.Model.length > 0 && self.GroupModel.Model.find(s=>s.modelID == null )) && self.GroupModel.isAllModel == false)) {
      */

        if (
          self.GroupModel.Name == "" ||
          self.GroupModel.Name == null ||
          (self.GroupModel.isAllModel == false &&
            self.GroupModel.Model.find((s) => !s.modelID))
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        // self.GroupModel.Model = (self.GroupModel.Model == null ? [] : self.GroupModel.Model);
        if (
          self.GroupModel.commandList.find(
            (x) => !x.label || !x.data || !x.type
          )
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }

        self.dialog = true;
        if (self.Adddialog) {
          await self.$call.CreateQuickReplyGroup(
            self.GroupModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Quick Reply Group Created " + dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                  backdrop: false,
                  position: 'top',
                  customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                  },
                });
                self.totalTable = self.totalTable + 1;
                self.Get();
                self.CommandClear();
                self.Adddialog = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              // self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (self.Editdialog) {
          await self.$call.UpdateModelQuickReply(
            self.GroupModel,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  title: "✔ Shortcut Menu Updated " + dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                  backdrop: false,
                  position: 'top',
                  customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title'
                  },
                });
                self.Get();
                self.CommandClear();
                self.Editdialog = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              // self.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },

    UploadImage() {
      let self = this;
      if (!self.requestUpload.entity) {
        alert("Please Fill All The Fields!");
        return;
      }

      // self.requestVector.vectordbName = self.$parent.$parent.$parent.KeyTopic;

      self.requestUpload.USER_CHANNEL = self.$root.User_Id;
      // self.requestVector.TopicID = self.$parent.$parent.$parent.Log_History_TopicID;

      self.loadingImage = true;
      try {
        self.$call.UploadImageModelQuick(
          self.requestUpload,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              // self.ImageURL = dataResponse.data;
              // self.requestUpload.entity = null;
              // self.uploadedFiles = [];
            } else {
              self.$swal.fire({
                icon: "error",
                title: this.$t("errorUploadImage"),
                showConfirmButton: false,
                timer: 2500,
              });
              self.ClearImage();
            }
            self.loadingImage = false;
          },
          (errorResource) => {
            self.$swal.fire({
              icon: "error",
              title: this.$t("errorUploadImage"),
              showConfirmButton: false,
              timer: 2500,
            });
            self.loadingImage = false;
            self.ImageURL = null;
            self.fileDataUrl = null;
            self.requestUpload.entity = null;
            console.error(errorResource);
          }
        );
      } catch (error) {
        // if(self.$parent.$parent.$parent.Log_History_TopicID == -1){
        self.GetTopicStream("Start");
        // }
        // this.LogTrace(error, 'DeleteGroup');

        console.log("catch : DeleteGroup");
      }
    },

    Plus_ModelQuick(index) {
      var that = this;
      that.GroupModel.Model.splice(index + 1, 0, {
        modelQuickID: null,
        name: "",
        modelID: null,
        modelQuickGroupID: null,
      });
    },
    Minus_ModelQuick(index) {
      var that = this;
      that.GroupModel.Model.splice(index, 1);
    },
    Plus_QuickReply(index) {
      var that = this;
      that.GroupModel.commandList.splice(index + 1, 0, {
        id: 0,
        label: null,
        data: null,
        type: null,
        createDate: null,
        createBy: null,
        updateDate: null,
        updateBy: null,
        modelQuickGroupID: null,
        iconFileURL: null,
        activeFlag: true,
      });
    },
    Minus_QuickReply(index) {
      var that = this;
      that.GroupModel.commandList.splice(index, 1);
    },

    getActiveQuickReplyFileInput() {
      return document.getElementById(this.Editdialog ? "inputfileQuickReply-edit" : "inputfileQuickReply-add");
    },

    resetQuickReplyFileInput() {
      const fileInput = this.getActiveQuickReplyFileInput();
      if (fileInput) fileInput.value = "";
    },

    showQuickReplyUploadError(text) {
      this.$swal.fire({
        title: "เกิดข้อผิดพลาด!",
        text,
        icon: "error",
      });
    },

    clearQuickReplyUploadError(text) {
      this.indexImportFile = null;
      this.resetQuickReplyFileInput();
      this.dialog = false;
      this.showQuickReplyUploadError(text);
    },

    getSelectedQuickReplyFile(e_para) {
      const file = e_para?.target?.files?.[0];
      return !file || file.size === 0 || this.indexImportFile == null ? null : file;
    },

    isSupportedQuickReplyFile(file) {
      return file.type == "image/jpeg" || file.type == "image/png";
    },

    hasQuickReplyFileExtension(file) {
      return file.name.lastIndexOf(".") > 0;
    },

    getResizedQuickReplyDimensions(width, height, maxWidth, maxHeight) {
      if (width > height && width > maxWidth) {
        return { width: maxWidth, height: height * (maxWidth / width) };
      }

      if (height >= width && height > maxHeight) {
        return { width: width * (maxHeight / height), height: maxHeight };
      }

      return { width, height };
    },

    loadQuickReplyImage(file, onLoad) {
      const MAX_WIDTH = 120;
      const MAX_HEIGHT = 80;
      const fr = new FileReader();

      fr.readAsDataURL(file);
      fr.addEventListener("load", (e) => {
        const img = document.createElement("img");
        img.onload = () => {
          const { width, height } = this.getResizedQuickReplyDimensions(img.width, img.height, MAX_WIDTH, MAX_HEIGHT);
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          ctx.canvas.width = width;
          ctx.canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          onLoad(canvas.toDataURL(file.type));
        };
        img.src = e.target.result;
      });
    },

    Click_FileButtonQuickReply(_indexImportFile) {
      const fileInput = this.getActiveQuickReplyFileInput();
      if (fileInput) fileInput.click();
      this.indexImportFile = _indexImportFile;
    },

    QuickReplyIcon(e_para) {
      try {
        this.dialog = true;
        const file = this.getSelectedQuickReplyFile(e_para);

        if (!file) {
          this.dialog = false;
          this.showQuickReplyUploadError("Something went wrong!");
          return;
        }

        if (!this.isSupportedQuickReplyFile(file) || !this.hasQuickReplyFileExtension(file)) {
          this.clearQuickReplyUploadError("ลองรับไฟล์ jpeg หรือ png เท่านั้น");
          return;
        }

        this.loadQuickReplyImage(file, (dataurl) => {
          this.GroupModel.commandList[this.indexImportFile].iconFileURL = dataurl;
          this.GroupModel.commandList[this.indexImportFile].imgName = file.name;
          this.resetQuickReplyFileInput();
          this.dialog = false;
        });
      } catch {
        this.clearQuickReplyUploadError("Something went wrong!");
      }
    },
  },
  mounted() {
    this.GetDate();
    this.GetQuickGroup();
  },
};
</script>
<style scoped>

.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0;
  padding: 0;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
/*#region Details Dialog*/

/* Dialog Base Styles */
/* .modern-dialog, */
.detail-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
  max-height: 90vh;
}

.detail-dialog {
  max-height: 85vh;
}

/* Dialog Headers */
/* .dialog-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
} */

.detail-header {
  background: linear-gradient(135deg, #4a90e2 0%, #357abd 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
}

.header-content,
.detail-header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

.detail-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

/* .dialog-subtitle, */
.detail-subtitle {
  font-size: 0.9rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.detail-subtitle {
  font-size: 0.85rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* .close-btn, */
.detail-close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

/* .close-btn:hover, */
.detail-close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
}

.count-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  font-weight: 600;
  backdrop-filter: blur(10px);
}

/* Dialog Content */
.dialog-content {
  padding: 32px 24px !important;
  background: #fafafa;
  max-height: 60vh;
  overflow-y: auto;
}

.detail-content {
  padding: 0 !important;
  background: #fafafa;
  max-height: 50vh;
  overflow-y: auto;
}

.models-container {
  padding: 24px;
}

/* Model List and Cards */
.model-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.model-item {
  position: relative;
}

.model-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  width: 100%;
  border: 1px solid var(--Field-border, #C9C9C9);
}

.model-card:hover {
  border-color: rgba(74, 144, 226, 0.2);
  box-shadow: 0 8px 25px rgba(74, 144, 226, 0.15);
  transform: translateY(-2px);
}

.model-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.model-info {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.model-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  border: 1px solid rgba(195, 46, 14, 0.25);
  background: rgba(195, 46, 14, 0.10);
  flex-shrink: 0;
}

.model-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.model-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  letter-spacing: 0.025em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.model-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  align-items: center;
}

.view-btn {
  border-radius: 10px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 80px;
  height: 36px;
  white-space: nowrap;
  border: 1px solid var(--main, #C32E0E);
  color: #C32E0E;
}

.view-btn:hover {
  background: #FDE4DF !important;
  transform: scale(1.05);
}

.model-divider {
  margin: 10px 0;
  border-color: rgba(74, 144, 226, 0.9);
}
/* Dialog Actions */
/* .dialog-actions, */
.detail-actions {
  padding: 20px 24px !important;
  background: white;
  border-top: 1px solid #e9ecef;
}

/* .actions-content, */
.detail-actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}

/* Buttons */
/* .dialog-action-btn {
  height: 44px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 120px;
} */

.detail-action-btn {
  height: 40px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 100px;
}

/* .cancel-btn, */
.close-action-btn {
  border: 2px solid #dee2e6 !important;
  color: #6c757d !important;
}

/* .cancel-btn:hover, */
.close-action-btn:hover {
  border-color: #adb5bd !important;
  background: #f8f9fa !important;
  transform: translateY(-1px);
}

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar,
.detail-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track,
.detail-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb,
.detail-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover,
.detail-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  /* .modern-dialog, */
  .detail-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
  
  .model-card {
    animation: modelCardFadeIn 0.3s ease forwards;
  }
  
  @keyframes modelCardFadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
}
/*#endregion Details Dialog*/

/* Modern Dialog Styles */
/* .modern-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
} */

/* Dialog Header */
/* .dialog-header {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
  color: white;
  padding: 24px !important;
  border-bottom: none;
}

.edit-header {
  background: linear-gradient(135deg, #f57c00 0%, #ef6c00 100%);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

.header-left {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.header-icon {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  color: white;
  letter-spacing: 0.025em;
}

.dialog-subtitle {
  font-size: 0.9rem;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
}

.header-right {
  display: flex;
  align-items: center;
}

.close-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  transform: scale(1.05);
} */

/* Dialog Content */
.dialog-content {
  padding: 32px !important;
  background: #ffffff;
  max-height: 70vh;
  overflow-y: auto;
}

.form-container {
  background: white;
  border-radius: 16px;
  padding: 15px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.form-section {
  margin-bottom: 0px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  color: #171717;
  letter-spacing: 0.025em;
}

.count-chip {
  background: rgba(33, 150, 243, 0.1) !important;
  color: #1565c0 !important;
  font-weight: 600;
}

/* Input Styling */
.input-wrapper {
  margin-bottom: 20px;
}

.input-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-weight: 600;
  color: #424242;
  font-size: 0.9rem;
  gap: 4px;
}

.required-asterisk {
  color: #d32f2f;
  font-weight: 700;
}

.help-icon {
  cursor: help;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.help-icon:hover {
  opacity: 1;
  color: #1976d2 !important;
  transform: scale(1.1);
}

.modern-input :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.modern-input :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modern-input :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.2);
}

/* Checkbox Styling */
.checkbox-wrapper {
  padding: 0px 12px;
  border-radius: 12px;
  border: 1px solid var(--Field-border, #C9C9C9);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #424242;
}

/* Import Button */
.import-btn {
  width: 100%;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  height: 44px;
}

.import-btn:hover {
  background: #1976d2 !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.3) !important;
}

/* Table Styling */
.table-container {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  margin-bottom: 16px;
}

.modern-table {
  background: white;
}

.table-header {
  background: #FFE4E1 !important;
  font-weight: 600 !important;
  font-size: 0.875rem !important;
  text-transform: none;
  letter-spacing: 0.5px;
  padding: 16px 12px !important;
}

.model-col {
  min-width: 200px;
}

.actions-col {
  width: 140px;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.table-row:hover {
  background: rgba(25, 118, 210, 0.02);
}

.table-cell {
  padding: 12px !important;
  vertical-align: middle;
}

.number-cell {
  text-align: start;
  font-weight: 600;
  color: #666;
}

.model-cell {
  min-width: 150px;
  max-width: 200px;
}
.label-cell{
  min-width: 180px!important;
}
.upload-cell,
.preview-cell {
  text-align: center;
}

.actions-cell {
  text-align: center;
}

/* Table Components */
.table-autocomplete :deep(.v-field),
.table-input :deep(.v-field) {
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.table-autocomplete :deep(.v-field:hover),
.table-input :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.table-autocomplete :deep(.v-autocomplete__menu-icon) {
  color: #872612;
  font-size: 32px;
  opacity: 1;
}

.upload-btn {
  border-radius: 8px !important;
  font-weight: 500;
  text-transform: none;
  white-space: nowrap;
  min-width: auto;
}

.image-preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-avatar {
  border: 2px solid #C9C9C9;
  transition: all 0.3s ease;
  padding: 10px;
  border-radius: 12px;
  width: 50px;
  height: 50px;
  margin: auto;
}

.preview-avatar.has-image {
  border-color: #1976d2;
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.2);
}

.preview-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.action-buttons {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.dialog-action-btn {
  transition: all 0.2s ease;
}

.dialog-action-btn:hover {
  transform: scale(1.1);
}

/* Info Messages */
.info-message {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: rgba(33, 150, 243, 0.08);
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-size: 0.875rem;
  color: #1565c0;
  margin-top: 16px;
}

.all-model-info {
  text-align: left;
  padding: 20px;
  border-radius: 16px;
  background: rgba(42, 191, 86, 0.10);
}

.info-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #2ABF56;
  align-items: center!important;
}

.info-subtitle {
  font-size: 16px;
  margin: 0;
  color: #646464;
  opacity: 0.8;
}

/* Dialog Actions */
/* .dialog-actions {
  padding: 24px 32px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.actions-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.actions-left {
  display: flex;
  align-items: center;
}

.actions-right {
  display: flex;
  gap: 12px;
}

.dialog-action-btn {
  height: 44px;
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 120px;
}

.cancel-btn {
  color: #757575 !important;
  border-color: #e0e0e0 !important;
}

.cancel-btn:hover {
  background: rgba(117, 117, 117, 0.04) !important;
  border-color: #bdbdbd !important;
  transform: translateY(-1px);
}

.save-btn {
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3) !important;
}

.save-btn:hover {
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.4) !important;
  transform: translateY(-1px);
}

.summary-chip {
  background: rgba(76, 175, 80, 0.1) !important;
  color: #2e7d32 !important;
  font-weight: 600;
} */

/* Scrollbar Styling */
.dialog-content::-webkit-scrollbar {
  width: 6px;
}

.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Responsive */
@media (max-width: 900px) {
  .dialog-header {
    padding: 20px 24px !important;
  }
  
  .dialog-content {
    padding: 24px !important;
  }
  
  .form-container {
    padding: 20px;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .modern-table {
    min-width: 800px;
  }
  
  .dialog-actions {
    padding: 20px 24px !important;
    flex-direction: column-reverse;
    gap: 16px;
  }
  
  .actions-content {
    flex-direction: column-reverse;
    gap: 16px;
    width: 100%;
  }
  
  .actions-right {
    width: 100%;
    flex-direction: column;
  }
  
  .dialog-action-btn {
    width: 100%;
  }
}

/* Animations */
@media (prefers-reduced-motion: no-preference) {
  .modern-dialog {
    animation: dialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  
  @keyframes dialogSlideIn {
    from {
      opacity: 0;
      transform: translateY(-30px) scale(0.95);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
}
/* Add Model Section */
.add-model-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  transition: all 0.3s ease;
}

.add-model-btn {
  border-radius: 12px !important;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.025em;
  transition: all 0.3s ease;
  min-width: 160px;
  height: 44px;
  border: 2px solid #4caf50 !important;
}

.add-model-btn:hover {
  background: #4caf50 !important;
  color: white !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.3) !important;
}

/* Import Dialog Specific Styles */
.import-dialog {
  max-width: 600px !important;
}

.import-header {
  background: linear-gradient(135deg, #00acc1 0%, #0097a7 100%);
}

.import-content {
  padding: 28px !important;
  background: #fafafa;
  max-height: none;
  overflow: visible;
}

.import-autocomplete :deep(.v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  background: white;
}

.import-autocomplete :deep(.v-field:hover) {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #00acc1 !important;
}

.import-autocomplete :deep(.v-field--focused) {
  box-shadow: 0 4px 16px rgba(0, 172, 193, 0.2);
  border-color: #00acc1 !important;
}

.import-autocomplete :deep(.v-field--focused .v-field__outline) {
  border-color: #00acc1 !important;
  border-width: 2px;
}

.import-autocomplete :deep(.v-label--active) {
  color: #00acc1 !important;
}

.import-autocomplete :deep(.v-autocomplete__menu-icon) {
  color: #872612;
  font-size: 32px;
  opacity: 1;
}

.import-info {
  background: rgba(0, 172, 193, 0.08);
  border-left: 4px solid #00acc1;
  color: #006064;
  margin-top: 16px;
}

.import-actions {
  padding: 24px 28px !important;
  background: white;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.import-btn-action {
  background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3) !important;
}

.import-btn-action:hover {
  background: linear-gradient(135deg, #43a047 0%, #2e7d32 100%) !important;
  box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4) !important;
  transform: translateY(-1px);
}

.import-btn-action:disabled {
  background: #e0e0e0 !important;
  color: #9e9e9e !important;
  box-shadow: none !important;
  transform: none !important;
}

/* Enhanced Input Styling for Import */
.import-autocomplete :deep(.v-input__prepend-inner) {
  padding-top: 12px;
}

.import-autocomplete :deep(.v-field__input) {
  padding-left: 8px;
}

.import-autocomplete :deep(.v-input__append-inner) {
  padding-top: 12px;
}

/* Animation for Import Dialog */
.import-dialog {
  animation: importDialogSlideIn 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

@keyframes importDialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Enhanced Summary Chip for Import */
.import-actions .summary-chip {
  background: rgba(0, 172, 193, 0.1) !important;
  color: #006064 !important;
  font-weight: 600;
}

/* Responsive for Import Dialog */
@media (max-width: 600px) {
  .import-dialog {
    max-width: 95vw !important;
    margin: 16px;
  }
  
  .import-content {
    padding: 20px !important;
  }
  
  .import-actions {
    padding: 20px !important;
    flex-direction: column-reverse;
    gap: 16px;
  }
  
  .actions-content {
    flex-direction: column-reverse;
    gap: 16px;
    width: 100%;
  }
  
  .actions-right {
    width: 100%;
    flex-direction: column;
  }
  
  .dialog-action-btn {
    width: 100%;
  }
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
</style>
